import React, { useEffect, useRef } from 'react'
import Chart from 'chart.js/auto'

const BarGraph = ({ data }) => {
  const chartRef = useRef(null)

  useEffect(() => {
    if (data.length > 0) {
      const labels = data.map(item => `${item.year}-${item.month}-${item.day}`)
      const counts = data.map(item => item.count)

      const ctx = chartRef.current.getContext('2d')
      const chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'Users',
              data: counts,
              backgroundColor: 'rgba(54, 162, 235, 0.5)',
              borderColor: 'rgba(54, 162, 235, 1)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          animation: {
            duration: 1000, // Animation duration in milliseconds
          },
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Count',
              },
            },
            x: {
              title: {
                display: true,
                text: 'Date',
              },
            },
          },
          plugins: {
            tooltip: {
              enabled: true,
              backgroundColor: 'rgba(0,0,0,0.7)',
            },
          },
        },
      })

      // Adding trend line chart
      // const trendData = calculateTrend(counts)
      // chartInstance.data.datasets.push({
      //   label: 'Trend',
      //   data: trendData,
      //   type: 'line',
      //   borderColor: 'rgba(255, 99, 132, 1)',
      //   borderWidth: 2,
      //   fill: false,
      //   yAxisID: 'trend-y-axis', // Use a separate y-axis for trend line
      // })

      chartInstance.update()

      return () => {
        chartInstance.destroy()
      }
    }
  }, [data])

  // Function to calculate trend data (simple moving average for example)
  // const calculateTrend = data => {
  //   // Implement your trend calculation logic here
  //   // For simplicity, let's use a simple moving average
  //   const windowSize = 3 // Adjust window size as needed
  //   const trendData = []
  //   for (let i = 0; i < data.length; i++) {
  //     if (i < windowSize - 1) {
  //       trendData.push(null) // For the first few data points, trend is not applicable
  //     } else {
  //       const sum = data.slice(i - windowSize + 1, i + 1).reduce((acc, val) => acc + val, 0)
  //       const average = sum / windowSize
  //       trendData.push(average)
  //     }
  //   }

  //   return trendData
  // }

  return (
    <div className='container mt-4'>
      <h3 style={{ marginLeft: '5rem' }}>User Report Bar & Line Graph</h3>
      <div>
        <div className='col-md-8'>
          <div className='card'>
            <div className='card-body'>
              <div className='chart-container' style={{ position: 'relative', height: '400px' }}>
                <canvas ref={chartRef}></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BarGraph
